import dayjs from 'dayjs/esm/index.js';

import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import LocaleData from 'dayjs/plugin/localeData';
import Weekday from 'dayjs/plugin/weekday';
import CustomParseFormat from 'dayjs/plugin/customParseFormat';
import isLeapYear from 'dayjs/plugin/isLeapYear';
import dayOfYear from 'dayjs/plugin/dayOfYear';
import utc from 'dayjs/plugin/utc';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';
import isBetween from 'dayjs/plugin/isBetween';

const currentLanguage = import.meta.env.VUE_APP_I18N_LOCALE?.split('_')[0];

(async () => {
  const languages = import.meta.glob('/node_modules/dayjs/esm/locale/*.js', { import: 'default' });
  const locale = await languages[`/node_modules/dayjs/esm/locale/${currentLanguage}.js`]();
  const enLocale = await languages['/node_modules/dayjs/esm/locale/en.js']();
  dayjs.updateLocale('en', enLocale);
  if (!locale) return;
  dayjs.locale({
    ...locale,
    weekStart: 1,
  });
})();

dayjs.extend(LocalizedFormat);
dayjs.extend(isLeapYear);
dayjs.extend(dayOfYear);
dayjs.extend(LocaleData);
dayjs.extend(Weekday);
dayjs.extend(CustomParseFormat);
dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(updateLocale);
dayjs.extend(relativeTime);
dayjs.extend(isBetween);

export { dayjs };

export default {
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$dayjs', { value: dayjs });
  },
};
